import React, { useState, useEffect, useRef } from "react";
import { Form } from "semantic-ui-react";

function handleScriptLoad(updateQuery, autoCompleteRef, autoComplete) {
  autoComplete = new window.google.maps.places.Autocomplete(
    autoCompleteRef.current,
    { componentRestrictions: { country: "us" } }
  );
  autoComplete.setFields(["address_components", "formatted_address"]);
  autoComplete.addListener("place_changed", () =>
    handlePlaceSelect(updateQuery, autoComplete)
  );
}

async function handlePlaceSelect(updateQuery, autoComplete) {
  const addressObject = autoComplete.getPlace();
  const query = addressObject.formatted_address;
  updateQuery(query);
  //console.log(addressObject);
}

function SearchLocationInput(props) {
  const [query, setQuery] = useState("");
  const {onChange} = props
  const {index} = props
  const autoCompleteRef = useRef(null);
  const autoComplete = {}

  useEffect(() => {
    handleScriptLoad(setQuery, autoCompleteRef, autoComplete)
  }, []);
  
  // useEffect(() => {
  //   onChange(query)
  //   // eslint-disable-next-line
  // }, [query])

  return (
    <Form.Field>
        <label>{props?.label}</label>
        <input
        name={props?.name}
        ref={autoCompleteRef}
        onChange={event => setQuery(event.target.value)}
        onBlur={() => {onChange(query, index)}}
        placeholder={props?.placeholder}
        value={query}
      />
    </Form.Field>
  );
}

export default SearchLocationInput;